import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {repoAgentsAppBuilder} from '../config/app-builder'
import type {RepoAgentsPayload} from '../types/repo-agents-payload'

/**
 * Landing page route configuration.
 *
 * Defined as a builder-parameterized factory so the same route wiring can be registered
 * under multiple apps (e.g. `repo-agents` and `repo`). Route configs are bound to the app
 * builder that creates them (embedded-data hydration + query-key app name), so each app
 * must build its own config rather than share a single instance.
 */
export function buildRepoAgentsRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('repoAgentsRoute', {
    path: '/:owner/:repo/agents',
    queries: [mainQuery<RepoAgentsPayload>()],
  })
}

/**
 * Route config bound to the `repo-agents` app builder, imported by components that read
 * this route's query data with static typing.
 */
export const repoAgentsRoute = buildRepoAgentsRoute(repoAgentsAppBuilder)
